/**
 * お気に入り一覧ページ（Wishlist Club）のカートボタンを、商品の販売状態で出し分ける
 *
 * アプリのカートボタン（.wcButton.wcFull）は Coming Soon・発売日を知らないため、
 * 商品ページ（snippets/product-buy-buttons.liquid）と同じ判定で出し分ける。
 * - Not For Sale・お問い合わせ商品（contact テンプレート）: カートボタンと数量を出さない
 * - Coming Soon（商品またはバリエーション）: 押せない「Coming Soon」
 * - 発売前（バリエーションの発売日時を優先、なければ商品の発売日時）: 押せない発売日の表示
 *   （日本語ページは「発売日：YYYY-MM-DD HH:MM」、英語ページは商品ページと同じ「Release Date: … JST」）
 * - それ以外: アプリのボタンをそのまま表示（売り切れの表示もアプリのまま）
 * 「すべてカートに入れる」は、一覧に Coming Soon・発売前などカートに入れられない商品があると隠す
 * （Coming Soon・発売前の商品までまとめてカートに入ってしまうため）。理由のメッセージは出さない。
 *
 * 販売状態は sections/wishlist-sale-status.liquid を Section Rendering API で読み込む。
 * 現在時刻はその応答の Date ヘッダー（サーバー時刻）を使う。端末の時計をずらしても変わらない。
 * 判定が終わるまでは、アプリのボタンを出さない（snippets/wishlist-club-sale-status.liquid のスタイル）。
 * 読み込みに失敗したときは1回だけやり直し、それでも失敗したら商品ページへのリンクを出す。
 * なお発売前の購入はカスタムアプリ Cart Brock（チェックアウトルール）でも止めている。
 *
 * snippets/wishlist-club-sale-status.liquid から、お気に入りページ（page.wishlist）でだけ読み込む。
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isJa = (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;
  var TEXT = isJa ? {
    upcoming: function (date) { return '発売日：' + date; },
    error: '販売状況を確認できませんでした。商品ページでご確認ください'
  } : {
    upcoming: function (date) { return 'Release Date: <br>' + date + ' JST'; },
    error: 'Could not check availability. Please see the product page.'
  };
  var MAX_ATTEMPTS = 2;
  var statusCache = {};

  // 商品ごとの販売状態とサーバー時刻（秒）を取得する。同じ商品は1回だけ読み込む
  function fetchStatus(handle) {
    if (!statusCache[handle]) {
      statusCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-sale-status', {
        cache: 'no-store'
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var serverDate = Date.parse(res.headers.get('Date') || '');
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var script = doc.querySelector('[data-wishlist-sale-status]');
          if (!script) throw new Error('販売状態が見つかりません');
          return {
            status: JSON.parse(script.textContent),
            now: Math.floor((isNaN(serverDate) ? Date.now() : serverDate) / 1000)
          };
        });
      });
      // 失敗したときは次の判定で読み込み直せるようにする
      statusCache[handle].catch(function () { delete statusCache[handle]; });
    }
    return statusCache[handle];
  }

  // 発売日時（UNIX 秒）を商品ページと同じ「YYYY-MM-DD / HH:MM」（JST）にする。日本語ページは「 / 」を空白にする
  function formatJst(unix) {
    var d = new Date((unix + 9 * 3600) * 1000);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) +
      (isJa ? ' ' : ' / ') + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes());
  }

  function findLink(card) {
    return card.querySelector('a[href*="/products/"]');
  }

  // カードの商品リンクからハンドルを取り出す
  function findHandle(card) {
    var link = findLink(card);
    if (!link) return null;
    var match = link.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // 選ばれているバリエーション ID（種類の選択欄、なければ商品リンクの ?variant=）
  function findVariantId(card) {
    var select = card.querySelector('.wcPcSelector');
    if (select && select.value) return select.value;
    var link = card.querySelector('a[href*="variant="]');
    var match = link && link.search.match(/variant=(\d+)/);
    return match ? match[1] : '';
  }

  // このスクリプトがカードに足したもの（押せないボタン・案内）を消す
  function clearAdded(card) {
    Array.prototype.forEach.call(card.querySelectorAll('.rw-wishlist-sale-upcoming, .rw-wishlist-sale-error'), function (el) { el.remove(); });
  }

  // カード内に、押せないボタンを置く（label は HTML。英語の Release Date の改行用）
  function showUpcoming(button, label) {
    var upcoming = document.createElement('button');
    upcoming.type = 'button';
    upcoming.className = 'rw-wishlist-sale-upcoming';
    upcoming.disabled = true;
    upcoming.innerHTML = label;
    button.insertAdjacentElement('afterend', upcoming);
  }

  // 判定できなかったときの案内（商品ページへのリンク）
  function showError(card, button) {
    var link = findLink(card);
    var note = document.createElement(link ? 'a' : 'p');
    note.className = 'rw-wishlist-sale-error';
    note.textContent = TEXT.error;
    if (link) note.href = link.href;
    button.insertAdjacentElement('afterend', note);
  }

  function setStatus(card, value) {
    card.setAttribute('data-sale-status', value);
    updateAllButton();
  }

  function processCard(card) {
    var button = card.querySelector('.wcButton.wcFull');
    if (!button) {
      // 売り切れなどでアプリがカートボタンを出していないときは、足したものを消して判定しない
      if (card.getAttribute('data-sale-status') !== 'no-button') {
        clearAdded(card);
        card.removeAttribute('data-sale-key');
        card.__rwSaleButton = null;
        setStatus(card, 'no-button');
      }
      return;
    }
    var handle = findHandle(card);
    var variantId = findVariantId(card);
    var key = handle + ':' + variantId;
    // 同じ商品・バリエーションで判定済み（判定中）なら何もしない
    if (card.getAttribute('data-sale-key') === key && card.__rwSaleButton === button) return;

    card.setAttribute('data-sale-key', key);
    card.__rwSaleButton = button;
    clearAdded(card);

    if (!handle) {
      showError(card, button);
      setStatus(card, 'error');
      return;
    }
    setStatus(card, 'checking');
    check(card, button, handle, variantId, key, 1);
  }

  function check(card, button, handle, variantId, key, attempt) {
    fetchStatus(handle).then(function (result) {
      // 判定中に種類が切り替わったときは、新しい判定に任せる
      if (card.getAttribute('data-sale-key') !== key) return;
      var status = result.status;
      var variant = status.variants[variantId] || { coming_soon: false, sale_start: 0 };
      var saleStart = variant.sale_start > 0 ? variant.sale_start : status.sale_start;

      if (status.not_for_sale || status.contact) {
        setStatus(card, 'hidden');
      } else if (status.coming_soon || variant.coming_soon) {
        showUpcoming(button, 'Coming Soon');
        setStatus(card, 'coming-soon');
      } else if (saleStart > result.now) {
        showUpcoming(button, TEXT.upcoming(formatJst(saleStart)));
        setStatus(card, 'upcoming');
      } else {
        setStatus(card, 'available');
      }
    }).catch(function (err) {
      if (card.getAttribute('data-sale-key') !== key) return;
      if (attempt < MAX_ATTEMPTS) {
        setTimeout(function () { check(card, button, handle, variantId, key, attempt + 1); }, 1500);
        return;
      }
      showError(card, button);
      setStatus(card, 'error');
      console.warn('お気に入りの販売状態を取得できませんでした', handle, err);
    });
  }

  // 「すべてカートに入れる」は、カートに入れられない商品（Coming Soon・発売前など）がないときだけ出す
  function updateAllButton() {
    var box = document.querySelector('.wishlistClubPage .wc_allAddtocartBtn');
    if (!box) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('.wishlistClubPage .WishlistClubContainer .wcProductCard'));
    var statuses = cards.map(function (card) { return card.getAttribute('data-sale-status'); });
    var allOk = cards.length > 0 && statuses.every(function (s) { return s === 'available' || s === 'no-button'; });
    box.setAttribute('data-sale-status', allOk ? 'available' : 'blocked');
  }

  function processAll() {
    // おすすめ商品（一覧の下のスライダー）にはカートボタンがないので、お気に入りの一覧だけを対象にする
    Array.prototype.forEach.call(document.querySelectorAll('.wishlistClubPage .WishlistClubContainer .wcProductCard'), processCard);
    updateAllButton();
  }

  function init() {
    processAll();
    // アプリは一覧を後から描画し、種類を切り替えるとカードを描き直すため、変化のたびに確認する
    new MutationObserver(processAll).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('.wcPcSelector')) {
        setTimeout(processAll, 0);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
